import axios from 'axios';
import config from './config';
const Communication = {
    getMethod(endpoint, data) {
        if (localStorage.getItem('token')) axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('token')}`
        return axios.get(config.baseUrl + endpoint, data)
            .then(response => {
                return response.data;
            })
    },
    postMethod(endpoint, data) {
        let headerData = {}
        if (localStorage.getItem('token')) {
            headerData = {
                headers: {
                    "Authorization": `Bearer ${localStorage.getItem('token')}`
                }
            }
        }
        return axios.post(config.baseUrl + endpoint, data, headerData)
            .then(
                response => {
                    return response.data;
                }
            )
            .catch(error => {
                // Add error handler
            })
    }
};
export default Communication;